

import { ApiHelper, IApiResponse } from "../../utils/api-helper";

const url = `${process.env.REACT_APP_API_ENDPOINT}/Identity`;

class RoleService extends ApiHelper {
  constructor(_url: string) {
    super(_url);
  }

  public getRole(): Promise<IApiResponse | void> {
    try {
      this.url = `${url}/Roles`;
      return super.get()
    } catch (e) {
      throw e;
    }
  }
}
const roleAPI = new RoleService(url);
export default roleAPI;
